import { Divider, Grid } from '@mui/material'
import { HearingSummaryProps } from 'components/HearingSummary'
import { validateChoiceField } from 'components/HearingSummary/utils/validate-field.util'
import Label from 'components/Label'
import React from 'react'
import { HearingCircumstancesType } from 'types/hearing-circumstances.type'
import { toBR } from 'utils/date.util'
import { formatAddressField } from 'utils/text.util'
import { validateField } from 'utils/validate.util'
import { Field } from '../Field'

export const CircumstanceGroup: React.FC<HearingSummaryProps<HearingCircumstancesType>> = ({
  data,
}) => {
  const factDateField = data && data.dtFato ? toBR(data.dtFato) : ''
  const arrestedDateField = data && data.dtApreensao ? toBR(data.dtApreensao) : ''

  return (
    <>
      <Label text='CIRCUNSTÂNCIAS DO FATO/APREENSÃO' v='h6' bold />
      <Divider />
      {factDateField && (
        <Grid container spacing={1} sx={{ mt: 1 }}>
          <Field label='Data do fato:' text={factDateField} fontWeight={400} />
          <Field label='Data da apreensão:' text={arrestedDateField} fontWeight={400} />
          <Field
            label='Local do pernoite:'
            text={validateField(data.localPernoite)}
            fontWeight={400}
          />
          <Field label='Endereço:' text={formatAddressField(data.endereco)} fontWeight={400} />
          <Field
            label='Maus tratos no momento da apreensão:'
            text={validateChoiceField(data.notConcretaTortura)}
            fontWeight={400}
          />
          <Field
            label='Breve relato da notícia:'
            text={validateField(data.breveRelatoNoticia)}
            fontWeight={400}
          />
          <Field
            label='Lesões corporais:'
            text={validateChoiceField(data.vestLesaoCorp)}
            fontWeight={400}
          />
          <Field
            label='Breve descrição dos vestígios:'
            text={validateField(data.brevDescVestigio)}
            fontWeight={400}
          />
          <Field
            label='Providência que será adotada:'
            text={validateField(data.providenciaAdotada)}
            fontWeight={400}
          />
        </Grid>
      )}
    </>
  )
}
